import axios from 'axios'
import Qs from 'qs'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'
import { Loading, Message } from 'element-ui' // 引用element-ui的加载和消息提示组件
import { Toast } from 'vant' // 引用element-ui的加载和消息提示组件
import { isPC } from "@/utils/browser";

const isPCPort = isPC();

const $axios = axios.create({
  // 设置超时时间
  timeout: 30000,
  // 基础url，会在请求url中自动添加前置链接
  baseURL: ''
})
Vue.prototype.$http = axios // 并发请求
// 在全局请求和响应拦截器中添加请求状态
let loading = null
let toast = null;
const interFace = ['get_sale_sum_by_date', 'get_refund_num', 'get_device_list', 'get_store_list', 'get_indicator_trend', 'get_data_by_company', 'get_company_list',
   'get_device_status', 'get_device_sale', 'get_device_index','get_sale_by_company_device_sku', 'get_goods_sale_sum', 'get_refund_by_status_by_devices',
    'get_refund_analysis', 'get_device_by_refund_reason', 'get_company_device_sort', 'get_sale_by_year',
    'get_sale_sum', 'get_goods_sum', 'get_erp_company_sum', 'get_refund_sum',
    'get_sale_amount_trend', 'get_goods_sum_trend', 'get_erp_company_trend', 'get_refund_trend',
    'get_source_trend', 'get_region_trend', 'get_company_type_trend', 'get_company_province_trend', 'get_company_name']
// 请求拦截器
$axios.interceptors.request.use(
  config => {
    // 已是完整 URL 时不再拼域名
    const isAbsolute = /^https?:\/\//i.test(config.url)
    if (!isAbsolute) {
      if (config.url.startsWith('/api/bi/basic') || config.url.startsWith('/api/bi/data_statistics')) {
        config.url = process.env.VUE_APP_STATISTICS_BASIC_API + config.url;
      }
      else if (config.url.startsWith('/api/auth')) {
        config.url = process.env.VUE_APP_AUTH_BASE_API + config.url
      }
      else if (config.url.startsWith('/api/bi')) {
        config.url = process.env.VUE_APP_BI_BASE_API + config.url
      }
      else {
        config.url = process.env.VUE_APP_BASE_API + config.url
      }
    }

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    // 允许业务侧关闭全局 Loading（并发请求会叠多层遮罩）
    if (!config.skipGlobalLoading) {
      if (isPCPort) {
        loading = Loading.service({ text: '拼命加载中' })
      } else {
        toast = Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
      }
    }

    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = token
    }
    console.log(666777, interFace.includes(config.url.split('/').pop()), store.getters.targetid)
    if(interFace.includes(config.url.split('/').pop()) && store.getters.targetid){
      config.headers['targetid'] = store.getters.targetid;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 处理 Blob 响应中的错误信息
async function handleBlobError(response) {
  try {
    // 尝试将 Blob 转换为文本
    const text = await response.data.text();
    
    // 尝试解析为 JSON
    const errorData = JSON.parse(text);
    
    // 如果解析成功且包含错误信息，则抛出错误
    if (errorData && (errorData.code !== 2000 || errorData.error || errorData.message)) {
      const errorMsg = errorData.message || errorData.msg || errorData.error || '下载失败';
      
      if (isPCPort) {
        Message.error(errorMsg);
      } else {
        Toast.fail(errorMsg);
      }
      
      return Promise.reject(errorData);
    }
    
    // 如果不是错误信息，重新构造 Blob 响应
    const blob = new Blob([text], { type: response.headers['content-type'] });
    return {
      ...response,
      data: blob
    };
    
  } catch (parseError) {
    // 如果无法解析为 JSON，说明确实是正常的文件内容
    return response;
  }
}

// 响应拦截器
$axios.interceptors.response.use(
  async response => {
    if (loading) {
      loading.close()
    }
    if (toast) {
      toast.clear(); // 关闭加载中的弹窗
    }
    
    const code = response.status;
    if ((code >= 200 && code < 300) || code === 304) {
      console.log('response', response);
      
      // 如果是blob类型的响应
      if (response.headers['content-type'] === 'application/octet-stream;charset=utf-8' ||
        response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
        response.headers['content-type'] === 'application/octet-stream' ||
        response.config.responseType === 'blob') {
        
        // 检查 Blob 响应是否包含错误信息
        return await handleBlobError(response);
      }
      
      // 业务成功码：历史接口 2000；新版销售分析 new_sale 文档为 0（兼容字符串）
      const bizCode = response.data && response.data.code
      const bizOk = bizCode == 2000 || bizCode == 0
      if (!bizOk) {
        // 如果业务状态码是401，表示token过期，需要特殊处理
        if (response.data.code === 401) {
          // 避免重复提示，只在有token时提示
          if (store.getters.token) {
            if (isPCPort) {
              Message.error('登录已过期，请重新登录')
            } else {
              Toast.fail('登录已过期，请重新登录');
            }
          }
          // 清除token信息并跳转到登陆页面
          store.commit('user/DEL_TOKEN')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          return Promise.reject(response.data)
        }
        return Promise.reject(response.data)
      } else {
        return Promise.resolve(response.data)
      }

    } else {
      return Promise.reject(response.data)
    }
  },
  error => {
    if (loading) {
      loading.close()
    }
    if (toast) {
      toast.clear(); // 关闭加载中的弹窗
    }
    console.log(error)

    // 业务失败（响应拦截里 Promise.reject({ code, msg })）不是网络错误，直接抛给调用方清空数据
    if (error && error.msg != null && error.code !== undefined && !error.response) {
      return Promise.reject(error)
    }

    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          // 避免重复提示，只在没有token或token已过期时提示
          if (store.getters.token) {
            if (isPCPort) {
              Message.error('登录已过期，请重新登录')
            } else {
              Toast.fail('登录已过期，请重新登录');
            }
          }
          // 返回401 清除token信息并跳转到登陆页面
          store.commit('user/DEL_TOKEN')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          break
        case 404:
          if (isPCPort) {
            Message.error('网络请求不存在')
          } else {
            Toast.fail('网络请求不存在');
          }

          break
        default:
          if (isPCPort) {
            Message.error((error.response.data && error.response.data.msg) || '请求失败')
          } else {

            Toast.fail((error.response.data && error.response.data.msg) || '请求失败')
          }

      }
    } else if (error && typeof error.message === 'string') {
      // 请求超时或者网络有问题
      if (error.message.includes('timeout')) {
        if (isPCPort) {
          Message.error('请求超时！请检查网络')
        } else {
          Toast.fail('请求超时！请检查网络')
        }

      } else {
        if (isPCPort) {
          Message.error('请求失败，请检查网络')
        } else {
          Toast.fail('请求失败，请检查网络')
        }

      }
    }
    return Promise.reject(error)
  }
)

export default {
  // 支持同时将参数放在 URL 查询字符串和请求体中的 post 函数
  post(url, data, params, responseType) {
    const axiosConfig = {
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    };
    if (params && responseType) {
      // 将参数放在 URL 的 query 中
      axiosConfig.params = params;
      axiosConfig.responseType = 'blob'
    } else {
      // 如果没有 params，则将参数放在请求体中
      axiosConfig.data = data;
    }
    return $axios(axiosConfig);
  },
  patch(url, data) {
    return $axios({
      method: 'patch',
      url,
      data,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    })
  },
  put(url, data) {
    return $axios({
      method: 'put',
      url,
      data,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    })
  },
  get(url, params, responseType) {
    const skipGlobalLoading = !!(params && params.skipGlobalLoading)
    const queryParams = params ? { ...params } : params
    if (queryParams && Object.prototype.hasOwnProperty.call(queryParams, 'skipGlobalLoading')) {
      delete queryParams.skipGlobalLoading
    }
    if (params && responseType || responseType) {
      const axiosConfig = {
        method: 'get',
        url,
        params: queryParams,
        skipGlobalLoading,
      };
      // 将参数放在 URL 的 query   return $axios(axiosConfig);
      axiosConfig.responseType = 'blob'
      return $axios(axiosConfig);
    }
    return $axios({
      method: 'get',
      url,
      params: queryParams,
      skipGlobalLoading,
    })
  },
  delete(url, params) {
    return $axios({
      method: 'delete',
      url,
      params
    })
  },
  files(url, formData) {
    return $axios({
      method: 'post',
      url,
      data: formData,
      headers: {
        'Content-Type': 'application/form-data; charset=UTF-8'
      }
    })
  }
}